module.exports = __webpack_public_path__ + "static/media/Sankey_Chart_Recording_App.261aa75f.mp4";